export const INITIAL_VALUES = ['width: 12rem'];

export function constructSnippet(
  values: Array<string> = INITIAL_VALUES
) {
  let codeSnippet = [...values].sort().join(';\n  ');
  if (codeSnippet) {
    codeSnippet = `\n  ${codeSnippet};`;
  }

  return `\
.element {
  position: fixed;${codeSnippet}
}`;
}
